module.exports = __webpack_public_path__ + "static/media/mario_0.f2d9e253.png";